interface Props {
  wishlistsCount?: number;
  activeListingsCount: number;
  latestListingAt?: string | null;
}

function daysSince(iso: string): number {
  const ms = Date.now() - new Date(iso).getTime();
  return Math.max(0, Math.floor(ms / (24 * 60 * 60 * 1000)));
}

export function GameSocialProof({ wishlistsCount, activeListingsCount, latestListingAt }: Props) {
  const items: { icon: React.ReactNode; text: string }[] = [];

  if (wishlistsCount && wishlistsCount > 0) {
    items.push({
      icon: (
        <svg className="h-4 w-4 text-rose-500" fill="currentColor" viewBox="0 0 24 24">
          <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
        </svg>
      ),
      text:
        wishlistsCount === 1
          ? "1 vartotojas stebi šį žaidimą"
          : `${wishlistsCount} vartotojai stebi šį žaidimą`,
    });
  }

  if (latestListingAt) {
    const days = daysSince(latestListingAt);
    let text: string;
    if (days === 0) text = "Naujas skelbimas šiandien";
    else if (days === 1) text = "Naujas skelbimas vakar";
    else if (days <= 7) text = `Naujas skelbimas prieš ${days} d.`;
    else text = null as unknown as string;

    if (text) {
      items.push({
        icon: (
          <svg className="h-4 w-4 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        ),
        text,
      });
    }
  }

  if (activeListingsCount > 1) {
    items.push({
      icon: (
        <svg className="h-4 w-4 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
        </svg>
      ),
      text: `${activeListingsCount} aktyvūs skelbimai`,
    });
  }

  if (items.length === 0) return null;

  return (
    <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-gray-600">
      {items.map((item, i) => (
        <span key={i} className="inline-flex items-center gap-1.5">
          {item.icon}
          {item.text}
        </span>
      ))}
    </div>
  );
}
